import { Injectable } from '@angular/core';

@Injectable()
export class AddressService {

    public getProvinces(): Array<{ key: string, value: string }> {
        return [
            { key: '0', value: 'Eastern Cape' },
            { key: '1', value: 'Free State' },
            { key: '2', value: 'Gauteng' },
            { key: '3', value: 'KwaZulu-Natal' },
            { key: '4', value: 'Limpopo' },
            { key: '5', value: 'Mpumalanga' },
            { key: '6', value: 'Northern Cape' },
            { key: '7', value: 'North West' },
            { key: '8', value: 'Western Cape' }
        ];
    }

    public getLocationTypes() : Array<{ key: string, value: string }> {
        return [
            { key: 'In-land', value: 'In-land' },
            { key: 'Coastal', value: 'Coastal' },
            { key: 'Namibia', value: 'Namibia' }
        ];
    }

    public getPosUnits() : Array<{ key: string, value: string }> {
        return [
            { key: 'HRK', value: 'HRK' },
            { key: 'GAAP', value: 'GAAP' },
            { key: 'PCtrl', value: 'PCtrl' },
            { key: 'SysPro', value: 'SysP' },
            { key: 'Bizzf', value: 'Bizzf' },
            { key: 'Micros', value: 'Micro' }
        ];
    }


    public getCountries(): Array<{ key: string, value: string }> {
        return [
            { key: '1', value: 'Afghanistan' },
            { key: '204', value: 'Aland Islands' },
            { key: '2', value: 'Albania' },
            { key: '3', value: 'Algeria' },
            { key: '4', value: 'American Samoa' },
            { key: '5', value: 'Andorra' },
            { key: '6', value: 'Angola' },
            { key: '7', value: 'Anguilla' },
            { key: '8', value: 'Antarctica' },
            { key: '9', value: 'Antigua And Barbuda' },
            { key: '10', value: 'Argentina' },
            { key: '11', value: 'Armenia' },
            { key: '12', value: 'Aruba' },
            { key: '202', value: 'Ascension' },
            { key: '13', value: 'Australia' },
            { key: '14', value: 'Austria' },
            { key: '15', value: 'Azerbaijan' },
            { key: '16', value: 'Bahamas' },
            { key: '17', value: 'Bahrain' },
            { key: '18', value: 'Bangladesh' },
            { key: '19', value: 'Barbados' },
            { key: '20', value: 'Belarus' },
            { key: '21', value: 'Belgium' },
            { key: '22', value: 'Belize' },
            { key: '23', value: 'Benin' },
            { key: '24', value: 'Bermuda' },
            { key: '25', value: 'Bhutan' },
            { key: '26', value: 'Bolivia' },
            { key: '27', value: 'Bosnia And Herzegovina' },
            { key: '28', value: 'Botswana' },
            { key: '29', value: 'Bouvet Island' },
            { key: '30', value: 'Brazil' },
            { key: '31', value: 'British Indian Ocean Territory' },
            { key: '32', value: 'Brunei Darussalam' },
            { key: '33', value: 'Bulgaria' },
            { key: '34', value: 'Burkina Faso' },
            { key: '35', value: 'Burundi' },
            { key: '36', value: 'Cambodia' },
            { key: '37', value: 'Cameroon' },
            { key: '38', value: 'Canada' },
            { key: '211', value: 'Canary Islands' },
            { key: '39', value: 'Cape Verde' },
            { key: '40', value: 'Cayman Islands' },
            { key: '41', value: 'Central African Republic' },
            { key: '42', value: 'Chad' },
            { key: '43', value: 'Chile' },
            { key: '44', value: 'China' },
            { key: '45', value: 'Christmas Island' },
            { key: '46', value: 'Cocos(Keeling) Islands' },
            { key: '47', value: 'Colombia' },
            { key: '48', value: 'Comoros' },
            { key: '49', value: 'Congo' },
            { key: '50', value: 'Congo, The Democratic Republic Of The' },
            { key: '51', value: 'Cook Islands' },
            { key: '52', value: 'Costa Rica' },
            { key: '53', value: 'Cte D Ivoire' },
            { key: '54', value: 'Croatia' },
            { key: '55', value: 'Cuba' },
            { key: '56', value: 'Cyprus' },
            { key: '57', value: 'Czech Republic' },
            { key: '58', value: 'Denmark' },
            { key: '206', value: 'Diego Garcia' },
            { key: '59', value: 'Djibouti' },
            { key: '60', value: 'Dominica' },
            { key: '61', value: 'Dominican Republic' },
            { key: '62', value: 'Ecuador' },
            { key: '63', value: 'Egypt' },
            { key: '64', value: 'El Salvador' },
            { key: '65', value: 'Equatorial Guinea' },
            { key: '66', value: 'Eritrea' },
            { key: '67', value: 'Estonia' },
            { key: '68', value: 'Ethiopia' },
            { key: '208', value: 'European Union' },
            { key: '69', value: 'Falkland Islands (Malvinas)' },
            { key: '70', value: 'Faroe Islands' },
            { key: '71', value: 'Fiji' },
            { key: '72', value: 'Finland' },
            { key: '73', value: 'France' },
            { key: '74', value: 'French Guiana' },
            { key: '75', value: 'French Polynesia' },
            { key: '76', value: 'French Southern Territories' },
            { key: '77', value: 'Gabon' },
            { key: '78', value: 'Gambia' },
            { key: '79', value: 'Georgia' },
            { key: '80', value: 'Germany' },
            { key: '81', value: 'Ghana' },
            { key: '82', value: 'Gibraltar' },
            { key: '83', value: 'Greece' },
            { key: '84', value: 'Greenland' },
            { key: '85', value: 'Grenada' },
            { key: '86', value: 'Guadeloupe' },
            { key: '87', value: 'Guam' },
            { key: '88', value: 'Guatemala' },
            { key: '210', value: 'Guernsey' },
            { key: '89', value: 'Guinea' },
            { key: '90', value: 'Guinea - Bissau' },
            { key: '91', value: 'Guyana' },
            { key: '92', value: 'Haiti' },
            { key: '93', value: 'Heard Island And Mcdonald Islands' },
            { key: '94', value: 'Holy See (Vatican City State)' },
            { key: '95', value: 'Honduras' },
            { key: '96', value: 'Hong Kong' },
            { key: '97', value: 'Hungary' },
            { key: '98', value: 'Iceland' },
            { key: '99', value: 'India' },
            { key: '100', value: 'Indonesia' },
            { key: '101', value: 'Iran, Islamic Republic Of' },
            { key: '102', value: 'Iraq' },
            { key: '103', value: 'Ireland' },
            { key: '212', value: 'Isle Of Man' },
            { key: '104', value: 'Israel' },
            { key: '105', value: 'Italy' },
            { key: '106', value: 'Jamaica' },
            { key: '107', value: 'Japan' },
            { key: '213', value: 'Jersey' },
            { key: '108', value: 'Jordan' },
            { key: '109', value: 'Kazakhstan' },
            { key: '110', value: 'Kenya' },
            { key: '111', value: 'Kiribati' },
            { key: '112', value: 'Korea, Democratic Peoples Republic Of' },
            { key: '113', value: 'Korea, Republic Of' },
            { key: '114', value: 'Kuwait' },
            { key: '115', value: 'Kyrgyzstan' },
            { key: '116', value: 'Lao Peoples Democratic Republic' },
            { key: '117', value: 'Latvia' },
            { key: '118', value: 'Lebanon' },
            { key: '119', value: 'Lesotho' },
            { key: '120', value: 'Liberia' },
            { key: '121', value: 'Libyan Arab Jamahiriya' },
            { key: '122', value: 'Liechtenstein' },
            { key: '123', value: 'Lithuania' },
            { key: '124', value: 'Luxembourg' },
            { key: '125', value: 'Macao' },
            { key: '126', value: 'Macedonia, The Former Yugoslav Republic Of' },
            { key: '127', value: 'Madagascar' },
            { key: '128', value: 'Malawi' },
            { key: '129', value: 'Malaysia' },
            { key: '130', value: 'Maldives' },
            { key: '131', value: 'Mali' },
            { key: '132', value: 'Malta' },
            { key: '133', value: 'Marshall Islands' },
            { key: '134', value: 'Martinique' },
            { key: '135', value: 'Mauritania' },
            { key: '136', value: 'Mauritius' },
            { key: '137', value: 'Mayotte' },
            { key: '138', value: 'Mexico' },
            { key: '139', value: 'Micronesia, Federated States Of' },
            { key: '140', value: 'Moldova' },
            { key: '141', value: 'Monaco' },
            { key: '142', value: 'Mongolia' },
            { key: '214', value: 'Montenegro' },
            { key: '143', value: 'Montserrat' },
            { key: '144', value: 'Morocco' },
            { key: '145', value: 'Mozambique' },
            { key: '146', value: 'Myanmar' },
            { key: '147', value: 'Namibia' },
            { key: '148', value: 'Nauru' },
            { key: '149', value: 'Nepal' },
            { key: '150', value: 'Netherlands' },
            { key: '151', value: 'Netherlands Antilles' },
            { key: '152', value: 'New Caledonia' },
            { key: '153', value: 'New Zealand' },
            { key: '154', value: 'Nicaragua' },
            { key: '155', value: 'Niger' },
            { key: '156', value: 'Nigeria' },
            { key: '157', value: 'Niue' },
            { key: '158', value: 'Norfolk Island' },
            { key: '159', value: 'Northern Mariana Islands' },
            { key: '160', value: 'Norway' },
            { key: '161', value: 'Oman' },
            { key: '162', value: 'Pakistan' },
            { key: '163', value: 'Palau' },
            { key: '164', value: 'Palestinian Territory, Occupied' },
            { key: '165', value: 'Panama' },
            { key: '166', value: 'Papua New Guinea' },
            { key: '167', value: 'Paraguay' },
            { key: '168', value: 'Peru' },
            { key: '169', value: 'Philippines' },
            { key: '170', value: 'Pitcairn' },
            { key: '171', value: 'Poland' },
            { key: '172', value: 'Portugal' },
            { key: '173', value: 'Puerto Rico' },
            { key: '174', value: 'Qatar' },
            { key: '175', value: 'Runion' },
            { key: '176', value: 'Romania' },
            { key: '177', value: 'Russian Federation' },
            { key: '178', value: 'Rwanda' },
            { key: '179', value: 'Saint Helena' },
            { key: '180', value: 'Saint Kitts And Nevis' },
            { key: '181', value: 'Saint Lucia' },
            { key: '182', value: 'Saint Pierre And Miquelon' },
            { key: '183', value: 'Saint Vincent And The Grenadines' },
            { key: '184', value: 'Samoa' },
            { key: '185', value: 'San Marino' },
            { key: '186', value: 'Sao Tome And Principe' },
            { key: '187', value: 'Saudi Arabia' },
            { key: '215', value: 'Saudiiraqi Neutral Zone' },
            { key: '188', value: 'Senegal' },
            { key: '189', value: 'Serbien Und Montenegro' },
            { key: '190', value: 'Seychelles' },
            { key: '191', value: 'Sierra Leone' },
            { key: '192', value: 'Singapore' },
            { key: '193', value: 'Slovakia' },
            { key: '194', value: 'Slovenia' },
            { key: '195', value: 'Solomon Islands' },
            { key: '196', value: 'Somalia' },
            { key: '197', value: 'South Africa' },
            { key: '198', value: 'South Georgia And The South Sandwich Islands' },
            { key: '219', value: 'Soviet Union' },
            { key: '199', value: 'Spain' },
            { key: '200', value: 'Sri Lanka' },
            { key: '216', value: 'Sudan' },
            { key: '201', value: 'Suriname' },
            { key: '218', value: 'Svalbard And Jan Mayen' },
            { key: '221', value: 'Swaziland' },
            { key: '217', value: 'Sweden' },
            { key: '205', value: 'Switzerland' },
            { key: '220', value: 'Syrian Arab Republic' },
            { key: '235', value: 'Taiwan' },
            { key: '226', value: 'Tajikistan' },
            { key: '236', value: 'Tanzania, United Republic Of' },
            { key: '225', value: 'Thailand' },
            { key: '228', value: 'Timor - Leste' },
            { key: '224', value: 'Togo' },
            { key: '227', value: 'Tokelau' },
            { key: '231', value: 'Tonga' },
            { key: '233', value: 'Trinidad And Tobago' },
            { key: '222', value: 'Tristan Da Cunha' },
            { key: '230', value: 'Tunisia' },
            { key: '232', value: 'Turkey' },
            { key: '229', value: 'Turkmenistan' },
            { key: '223', value: 'Turks And Caicos Islands' },
            { key: '234', value: 'Tuvalu' },
            { key: '238', value: 'Uganda' },
            { key: '237', value: 'Ukraine' },
            { key: '203', value: 'United Arab Emirates' },
            { key: '209', value: 'United Kingdom' },
            { key: '239', value: 'United States' },
            { key: '240', value: 'Uruguay' },
            { key: '241', value: 'Uzbekistan' },
            { key: '246', value: 'Vanuatu' },
            { key: '242', value: 'Venezuela' },
            { key: '245', value: 'Viet Nam' },
            { key: '243', value: 'Virgin Islands, British' },
            { key: '244', value: 'Virgin Islands, U.S' },
            { key: '247', value: 'Wallis And Futuna' },
            { key: '207', value: 'Western Sahara' },
            { key: '248', value: 'Yemen' },
            { key: '249', value: 'Zambia' },
            { key: '250', value: 'Zimbabwe ' }
        ];
    }
};


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/address.service.ts